import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import reducer from './reducer'

//this code is deprecated
const store = createStore(reducer, applyMiddleware(thunk))
//Change to new code
/*const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
});*/

export default store
